import styled from "styled-components";

export const SavingsStampLottieContainer = styled.div({
    width: "145px",
    position: "absolute",
    bottom: "-10px",
    right: "-4px",
});
